import React, { memo } from 'react';
import PropTypes from 'prop-types';

import TermFilterLabel from '../TermFilterLabel';

import { Wrapper, TermFilterItem, TermFilterValue } from './styles';

const TermsFilters = memo(({ terms, filters, onRequestChange }) => (
  <Wrapper>
    {terms.map(({ type, color, value, name, disabled }) => (
      <TermFilterItem
        key={value}
        checked={!disabled && filters[value]}
        disabled={disabled}
        title={value}
        onClick={() => onRequestChange(value)}
      >
        <TermFilterLabel type={type} color={disabled ? 'gray' : color} />

        <TermFilterValue>{name || value}</TermFilterValue>
      </TermFilterItem>
    ))}
  </Wrapper>
));

TermsFilters.propTypes = {
  terms: PropTypes.arrayOf(PropTypes.object).isRequired,
  filters: PropTypes.objectOf(PropTypes.bool).isRequired,
  onRequestChange: PropTypes.func,
};

TermsFilters.defaultProps = {
  onRequestChange: () => {},
};

export default TermsFilters;
